Ext.namespace('utils.grid.event');

utils.grid.event = (function( $, Ext, window, undefined ){
    var public = new Object(), scope = null;
	
    public.init = function(){
		var funs = scope.utils.grid.event();
		var purview = app.config.purview;
		
		$(document).on('click', '.list-button-edit', funs.onEdit);
		$(document).on('click', '.list-button-delete', funs.onDelete);
		$(document).on('click', '.list-button-top', funs.onTop);
		$(document).on('click', '.list-button-untop', funs.onTop);

		if(purview)
		{
			if(purview.write)
			{
				$(document).on('click', '.list-button-status', funs.onEnable);
			}
		}
    };
	
    public.setScope = function(_scope){
		scope = _scope;
    };
	
	public.onSearch = function(params){
		params = typeof(params) == 'undefined' ? {} : scope.utils.grid.params();

		scope.window.view.getGrid().store.load({
			params: Ext.apply(params, scope.window.view.params)
		});
	};
	
	public.onSearchClear = function(){
		var params = scope.utils.grid.params();
		var funs = scope.utils.grid.event();
		var el = null;
		
		funs.onSearch();
		
		for(var x in params) 
		{
			el = Ext.get(x);
			
			if(el) el.dom.value = '';
		}
	};
		
	public.onDelete = function(rowId){
		typeof rowId == 'string' ? true : rowId = $(this).attr('data-id');
		
		rowId = rowId.split(',');
				
		Ext.MessageBox.confirm('系統提示', '是否刪除資料?', function(type){
			if(type == 'yes')
			{
				Ext.Ajax.request({
					url: app.config.url.delete,
					params: {'rowId[]' : rowId},   
					method: 'POST',
					success: function (v,c) {
						var result = Ext.decode(v.responseText);
						
						if (result.success)
						{
							top.toastr.success(result.message);
							
							scope.window.view.getGridStore().reload();
						}
						else top.toastr.error(result.message);
					}
				});
			}
		});
	};

	getURLAddLang = function(url){
		return url + (url.search("\\?") == -1 ? "?" : "&") + "lang=" + top.app.config.lang;
	};
	
	public.onAdd = function(){
		var page = app.config.editpage;
		
		if(page)
		{
			top.units.getCmpPage(page.title, page.code, getURLAddLang(page.url));

			return ;	
		}
		
		scope.lightBox.form.show();
		scope.window.form.reset();
	};
	
	public.onEdit = function(rowId){
		typeof rowId == 'string' ? true : rowId = $(this).attr('data-id');
		
		var page = app.config.editpage;
		
		if(page)
		{
			var url = $.php.sprintf("%s?rowId=%d", page.url, rowId);
			
			top.units.getCmpPage(page.title, page.code, getURLAddLang(url));

			return ;	
		}

		scope.lightBox.form.show();
		scope.window.form.reset(); 

		Ext.getCmp("button-save").setDisabled(false);
		
		scope.window.form.load({
			waitMsg: '資料處理中..',
			waitTitle: '系統提示',
			url: app.config.url.info,
			params: {rowId: rowId},   
			method: 'POST',
			failure: function (form, action) {
				if(action.result) top.toastr.error(action.result.message);
				
				scope.lightBox.form.hide();
				scope.window.view.getGridStore().reload();
			}
		});
	};
	
	public.onGrougEvent = function(ele, rec, idx){
		var rows = scope.window.view.getGrid().getSelectionModel().getSelections();
		var rowId = [];
		var funs = scope.utils.grid.event();

		for(var i = 0; i < rows.length; i++)
		{
			rowId.push(rows[i].get('rowId'));
		}

		if (!rows.length)
		{
			top.toastr.error('尚未勾選任何資料.');
			
			return false;
		}
		
		switch(ele.value)
		{
			case 'delete':
				funs.onDelete(rowId.join(','));
			break;
		}
		
		ele.setValue(''); 
	};
	
	public.onEnable = function(){
		Ext.Ajax.request({
			url: app.config.url.enable,
			params: {'rowId' : $(this).attr('data-id')},   
			method: 'POST',
			success: function (v,c) {
				var result = Ext.decode(v.responseText);
				
				if (result.success)
				{
					top.toastr.success(result.message);
					
					scope.window.view.getGridStore().reload();
				}
				else top.toastr.error(result.message);
			}
		});
	};
			    
	public.onIemsAdd = function(){
		var view = scope.window.view, e, 
			add = utils.clone(view.config.plugins.editor.add);
		
		e = new view.component.editor.create(add);
		
		view.component.editor.ux.stopEditing();
		
		view.getGridStore().insert(0, e);
		view.getGrid().getView().refresh();
		view.getGrid().getSelectionModel().selectRow(0);
		
		view.component.editor.ux.startEditing(0);
	};
			    
	public.onIemsSave = function(roweditor, changes, record, rowIndex){
		roweditor.form.submit({
			waitTitle: '系統提示',
			waitMsg: '資料處理中..',
			url: app.config.url.save,
			method: 'POST',
			params: {rowId: record.get('rowId')},  
			success: function(form, action){
				var result = action.result;

				if (result.success)
				{
					top.toastr.success(result.message);
					
					scope.window.view.getGridStore().reload();
				}
				else top.toastr.error(result.message);
			},
			failure : function(form, action){
				if(action.result) 
				{
					Ext.MessageBox.alert('提示', action.result.message);
				}
			}
		});
	};
			    
	public.onIemsCancel = function(roweditor){
		var view = scope.window.view;

		var s = view.getGridStore().getRange();
		for (var i = 0; i < s.length; i++) 
		{
			r = s[i];
			
			if (r.data.rowId == '') view.getGridStore().remove(r);
		}
	};
	
	public.onIemsSort = function(grid) {
		var ddrow = new Ext.dd.DropTarget(grid.container, {
			ddGroup : 'dd',
			copy:false,
			notifyDrop : function(dd, e, data){
				var store = scope.window.view.getGridStore();
				var rows = data.selections;
				var index = dd.getDragData(e).rowIndex;
				var isDropSort = true;
				
				if (typeof(index) == "undefined") return;
	
				for(i = 0; i < rows.length; i++) 
				{
					if(store.indexOf(rows[i]) == index) isDropSort = false;
				}
				
				if(!isDropSort) return false;
				
				for(i = 0; i < rows.length; i++) 
				{
					var rowData = rows[i];
					if(!this.copy) store.remove(rowData);
					store.insert(index, rowData);
				}
				
				var data = scope.window.view.getGridStore().getRange();
				var update = [];
				
				for (var i = 0; i < data.length; i++) update.push(data[i].data.rowId);
				
				Ext.Ajax.request({
					url: app.config.url.sort,
					params: {'rowId[]' : update},   
					method: 'POST',
					success: function (v,c) {
						var result = Ext.decode(v.responseText);
						
						if (result.success)
						{
							top.toastr.success(result.message);
							
							scope.window.view.getGridStore().reload();
						}
						else top.toastr.error(result.message);
					}
				});
			}
		});
	};
	
	public.onTop = function(){
		var rowId = $(this).attr('data-id');
		var type = $(this).hasClass('button-untop') ? 'untop' : 'top';

		Ext.Ajax.request({
			url: app.config.url.top,
			params: {'rowId': rowId, 'type': type},   
			method: 'POST',
			success: function (v,c) {
				var result = Ext.decode(v.responseText);
				
				if (result.success)
				{
					scope.window.view.getGridStore().reload();
				}
				else top.toastr.error(result.message);
			}
		});
	};
			    
    return public;
}( jQuery, Ext, window ));

